import React from 'react';
import './LZPrivacyDetailPage.css';

class LZPrivacyDetailPage extends React.Component {
    constructor(props) {
        super(props);
        
    }

    componentDidMount() {
        
    }

    render() {
        return (
            <div className='container'>
                <div class="main-header">《莱泽隐私政策》2023年6月15日生效版本</div>
                <a class="main-header" href='https://www.laizekeji.cn/hxcomponent/index.html?to=privacySDKList'>《莱泽之家第三方SDK列表》</a>
                <body class="main-content">
                    <h4 className='contentHeader'>【特别提示】</h4>
                    <div className='boldContent'>本政策仅适用于温州莱泽气动科技有限公司（以下或称“我们”或“莱泽”）提供的产品和服务及其延伸的功能（以下简称“莱泽服务”），包括莱泽之家APP、网站、客户端以及随技术发展出现的新形态向您提供的各项产品和服务。如我们提供的某款产品有单独的隐私政策或相应的用户服务协议当中存在特殊约定，则该产品的隐私政策将优先适用，该款产品隐私政策和用户服务协议未涵盖的内容，以本政策内容为准。</div>
                    <div className='boldContent'>请仔细阅读《莱泽隐私政策》（尤其是粗体内容）并确定了解我们对您个人信息的处理规则。阅读过程中，如您有任何疑问，可通过《莱泽隐私政策》中的联系方式咨询我们。</div>
                    <div>版本更新日期：2023年6月15日</div>
                    <div>版本生效日期：2023年6月15日</div>
                    <div>如您有任何疑问、意见或建议，您可通过以下联系方式与我们联系：</div>
                    <div>联系电话：400-686-0606</div>
                    <div>联系邮箱：laizekj@laizekj.com</div>
                    <div>注册地址：浙江省温州市乐清市柳市镇捷达路332-356号</div>
                    <br/>
                    <h4 className='contentHeader'>引言</h4>
                    <div>
                        欢迎您使用莱泽之家！我们非常重视用户的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关信息。我们希望通过《莱泽隐私政策》（“本隐私政策”）向您说明在您使用我们的产品与/或服务时我们如何收集、使用、保存、共享和转移这些信息，以及我们为您提供的访问、更新、删除和保护这些信息的方式。
                    </div>
                    <div>本隐私政策将帮助您了解以下内容：</div>
                    <div>一、我们如何收集和使用您的个人信息</div>
                    <div>二、我们如何使用 Cookies 和同类技术</div>
                    <div>三、我们如何共享、转让、公开披露、合理使用您的个人信息</div>
                    <div>四、我们如何保护和保存您的个人信息</div>
                    <div>五、您如何管理个人信息</div>
                    <div>六、未成年人的个人信息保护</div>
                    <div>七、通知和修订</div>
                    <div>八、如何联系我们</div>
                    <br/>
                    <div className='boldContent'>
                        本隐私政策与您所使用的莱泽服务以及该服务所包括的各种业务功能（以下统称“我们的产品与/或服务”）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分理解本隐私政策所写明的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。本隐私政策中涉及的相关术语，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您更好地理解。
                    </div>
                    <br/>
                    <h4 className='contentHeader'>一、我们如何收集和使用您的个人信息</h4>
                    <div>
                        在您使用我们的产品与/或服务时，您需要授权我们收集和使用个人信息的场景包括：
                    </div>
                    <div>
                        1、为了向您提供我们服务的基本功能，您需要授权我们收集、使用必要信息的情形，如您拒绝提供前述必要信息，您将无法正常使用我们的产品与/或服务；
                    </div>
                    <div>
                        2、为了向您提供我们产品与/或服务的拓展功能，您可以选择授权我们收集、使用信息的情形，如您拒绝提供前述信息，您将无法正常使用相关附加功能或无法实现我们拟达到的功能效果。
                    </div>
                    <div className='boldContent'>（一）您需要授权我们收集和使用您个人信息的情形</div>
                    <div className='boldContent'>
                        我们的产品与/或服务包括一些核心功能，这些功能包含了注册账号所必须的功能、购买产品与/或服务所必须的功能、改进我们的产品与/或服务所必须的功能及保障交易安全所必须的功能。我们可能会收集、保存和使用下列与您有关的信息才能实现上述这些功能。如果您不提供相关信息，您将无法享受我们提供的产品与/或服务。这些功能包括：
                    </div>
                    <div className='boldContent'>1、用户注册</div>
                    <div>
                        您首先需要注册一个温州莱泽气动科技有限公司账号（以下简称“莱泽账号”）成为我们的用户。当您注册时，您需要至少向我们提供您本人的手机号码，我们将通过发送短信验证码的方式来验证您的身份是否有效，并完善相关的网络身份识别信息（如头像、用户名及登录密码等）；如果您仅需使用浏览、搜索等功能，您无需注册成为我们的用户以及提供上述信息。如果您选择授权使用第三方账号登陆时，我们会从第三方获取您共享的账号信息（如头像、昵称、地区、性别等信息）与您的莱泽账号进行绑定用于快捷登录，我们会依据与第三方的约定，在符合相关法规的前提下使用您的个人信息。我们需要您授权从第三方获取上述信息是为了记住您作为莱泽用户的登录身份，以向您提供更优质的产品与/或服务。我们仅会在您的授权同意的范围内收集并使用您的个人信息。
                    </div>
                    <div className='boldContent'>2、向您提供基于地理位置的信息展示</div>
                    <div>
                        为了向您提供周边服务及出行信息的展示和搜索服务，提升我们的服务表现、效率和功能，经您授权我们会收集您在使用我们服务过程中产生的相关信息，包括：
                    </div>
                    <div className='boldContent'>（1）位置信息</div>
                    <div>
                        当您通过系统授权开启移动设备的定位功能并使用基于位置提供的服务时，我们会收集和使用您的位置信息以便为您推荐周边的生活服务（例如您不需要手动输入所在地理位置就可获得相关服务，估算商家与您之间的实际距离方便您进行消费决策，为您推荐附近的优惠信息等）。我们会使用有关技术获取您的位置信息（准确度会有所不同），这些技术包括 IP 地址、GPS 以及能够提供相关信息的WLAN（如Wi-Fi） 接入点、蓝牙和基站等。您可以在移动设备的系统中关闭定位服务停止我们对您所在位置信息的收集，但可能因此无法使用我们基于地理位置为您提供的服务，或者无法达到相关服务的预期效果。
                    </div>
                    <div className='boldContent'>（2）日志信息</div>
                    <div>
                        当您使用我们提供的产品/服务时，我们会收集您的浏览、搜索记录等信息并作为有关网络日志进行保存，包括您的IP地址、浏览器的类型、使用的语言、操作系统的版本、访问的日期和时间、发布的信息、浏览、搜索、网络请求等。请您理解，单独的设备信息、日志信息等是无法识别特定自然人身份的信息。除非将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，那么在结合使用期间，这类非个人信息将被视为个人信息，我们会将该类个人信息做匿名化、去标识化处理（取得您的授权或法律法规另有规定的情况除外）。当您与我们联系时，为验证您的身份，帮助您解决问题，我们可能会记录您与我们的对话并收集其他为解决问题所需的必要信息。
                    </div>
                    <div className='boldContent'>3、用户留言</div>
                    <div>
                        当您在浏览我们进行产品及服务的咨询时，可以在线提交留言，我们会将您填写的留言内容、电话等信息进行收集以便给让产品及服务提供者及时与您联系，更好的为您服务。
                    </div>
                    <div className='boldContent'>4、消息推送</div>
                    <div>
                        当您在客服页面进行产品及服务的咨询时，当APP进入后台我们也将为您推送客服发送的消息。如您不想接收APP发送的消息通知，可以通过在系统设置中关闭。
                    </div>
                    <div className='boldContent'>（1）自启动和关联启动说明</div>
                    <div style={{textIndent:'4em'}}>i）为确保本应用处于关闭或后台运行状态下可正常接收到客户端推送的信息，本应用须使用（自启动）能力，将存在于一定频率通过系统发送广播唤醒本应用自启动或关联启动行为，是因为实现功能及服务所必要的。</div>
                    <div style={{textIndent:'4em'}}>ii）当您打开内容类推送信息，在征得您的明确同意后，会跳转打开相关内容。在未征得您同意的情况下，则不会有自启动或关联启动。</div>
                    <div style={{textIndent:'4em'}}>iii）当您打开本App内部下载的文件后，会关联启动第三方App。</div>
                    <br/>
                    <div>
                        您首先需要注册一个温州莱泽气动科技有限公司账号（以下简称“莱泽账号”）成为我们的用户。当您注册时，您需要至少向我们提供您本人的手机号码，我们将通过发送短信验证码的方式来验证您的身份是否有效，并完善相关的网络身份识别信息（如头像、用户名及登录密码等）；如果您仅需使用浏览、搜索等功能，您无需注册成为我们的用户以及提供上述信息。如果您选择授权使用第三方账号登陆时，我们会从第三方获取您共享的账号信息（如头像、昵称、地区、性别等信息）与您的莱泽账号进行绑定用于快捷登录，我们会依据与第三方的约定，在符合相关法规的前提下使用您的个人信息。我们需要您授权从第三方获取上述信息是为了记住您作为莱泽用户的登录身份，以向您提供更优质的产品与/或服务。我们仅会在您的授权同意的范围内收集并使用您的个人信息。
                    </div>
                    <div className='boldContent'>（二）向您提供我们的产品与/或服务</div>
                    <div className='boldContent'>1、信息发布功能</div>
                    <div>
                        我们平台最主要的功能就是信息发布功能，您可以根据您的需要选择发布信息的行业类目。当您使用发布功能时，我们会收集您的个人信息（信息品类不同，收集的信息不一样），包括姓名、联系方式、个人信息资料、地理位置、用户相册、邮箱、地址信息。此类信息为您自己主动填写的信息，收集是为了方便您能成功发布信息，可以更快捷的与您发布的内容进行匹配。
                    </div>
                    <div className='boldContent'>2、搜索/收藏功能</div>
                    <div>
                        当您使用我们提供的搜索、收藏功能时，我们会收集您查询的关键字信息以及您在使用我们的服务时所浏览或收藏的其他信息和内容详情。为了给您带来更便捷的搜索服务并不断完善我们的产品与/或服务。该等关键词信息通常无法单独识别您的个人身份，不属于您的个人信息，不在本隐私保护声明的限制范围内。只有当您的搜索关键词信息与您的其他信息有联结并可识别您的个人身份时，则在结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，与您的搜索历史记录一同按照本隐私保护声明对其进行处理与保护。
                    </div>
                    <div className='boldContent'>3、身份认证服务</div>
                    <div>
                        我们提供身份认证服务，在对您个人信息的真实性进行审核后，会为您标记认证标识。 因此，当您申请我们为您进行身份认证时，我们需要收集您的姓名、身份证号等有关身份证明的信息，以证实您的个人身份相关信息，具体验证的方式以“个人中心”——“账号安全”——“我要认证”显示的为准，您可以根据需要自行选择认证的方式。我们还可能需要收集您的生物识别信息，用于人脸验证。例如，您提交个人认证，需要提供您的身份证信息，以便我们进行核实。
                    </div>
                    <div className='boldContent'>4、客户服务</div>
                    <div>
                        当您向我们发布信息、申诉或进行咨询时，为了方便与您联系或帮助您解决问题，我们可能需要您提供姓名、手机号码、电子邮件信息。如您拒绝提供上述信息，可能部分功能无法使用，同时无法向您及时反馈申诉或咨询结果。
                    </div>
                    <div className='boldContent'>5、营销活动</div>
                    <div>
                        我们将会不时举办线上或线下的营销活动，包括邀请用户奖励红包、赠送优惠券、赠送礼品等活动。在此类营销活动中，我们可能需要用户提供个人信息（如手机号、邮编、地址信息），以便我们能够给用户发放奖励或寄送礼品。
                    </div>
                    <div className='boldContent'>6、支付功能</div>
                    <div>
                        您在温州莱泽气动科技有限公司进行服务支付购买。在您使用该服务的过程中可能会需要进行支付，在支付过程中， 我们可能会收集您的第三方支付帐号(例如支付宝帐号或其他形式的支付信息)。
                    </div>
                    <div className='boldContent'>（三）为您提供其他附加服务</div>
                    <div className='boldContent'>1、基于位置信息的个性化推荐功能</div>
                    <div>
                        我们会收集您的位置信息（我们仅收集您当时所处的地理位置，但不会将您各时段的位置信息进行结合以判断您的行踪轨迹）来判断您所处的地点。
                    </div>
                    <div className='boldContent'>2、基于相册（图片库/视频库）的图片/视频访问及上传的附加服务</div>
                    <div>
                        您可在开启相册权限后使用该功能上传您的照片/图片/视频，以实现更换头像、展现或与客服沟通提供证明等功能。您可以在温州莱泽气动科技有限公司上传您的照片/视频来实现您想要发布的推广信息的编辑发布。
                    </div>
                    <div className='boldContent'>3、其他服务</div>
                    <div>
                        1）除上述我们向您提供的产品和服务外，我们还可能为了提供服务及改进服务质量的合理需要而收集您的其他信息，包括您与我们的客户服务团队联系时所提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息。与此同时，为提高您使用我们平台提供的服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，我们可能会通过了解一些您的网络使用习惯、您常用的软件信息等手段来判断您账号的风险，并可能会记录一些我们认为有风险的URL。
                    </div>
                    <div>
                        2）在不透露单个用户隐私资料的前提下，我们有权对整体用户数据库进行分析并对用户数据库进行商业上的利用。我们可能会对网络服务使用情况进行统计。同时，我们可能会与公众分享这些统计信息，以展示我们服务的整体使用趋势。这些统计信息不包含您的任何身份识别信息。
                    </div>
                    <div className='boldContent'>（四）征得授权同意的例外情况</div>
                    <div>1、与国家安全、国防安全直接相关的；</div>
                    <div>2、与公共安全、公共卫生、重大公共利益直接相关的；</div>
                    <div>3、与犯罪侦查、起诉、审判和判决执行等直接相关的；</div>
                    <div>4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</div>
                    <div>5、所收集的个人信息是您自行向社会公众公开的；</div>
                    <div>6、从合法公开披露的信息中收集到您的个人信息，如从合法的新闻报道、政府信息公开等渠道；</div>
                    <div>7、根据您的要求签订和履行合同所必需的；</div>
                    <div>8、法律法规规定的其他情形。</div>
                    <div>
                        您知悉并认可：我们通过广告或其他方式向您提供链接，使您可以接入第三方服务或网站。您使用该等第三方的服务时，须受该第三方的服务条款及隐私保护声明约束，我们提示您需要仔细阅读其声明。本协议仅适用于我们提供的服务器所收集的信息，并不适用于第三方提供的服务或第三方的信息使用的规则，我们对第三方使用由您自行提供的信息不承担责任。
                    </div>
                    <div className='boldContent'>（五）详细权限和使用目的</div>
                    <div>
                        上述扩展功能可能需要您在您的设备中向我们开启您的地理位置（位置信息）、相机（摄像头）、相册（图片库），以实现这些功能所涉及的信息的收集和使用。您可以在莱泽之家APP或设备系统中逐项查看您上述权限的开启状态，并可以决定将这些权限随时的开启或关闭（我们会指引您在您的设备系统中完成设置）。请您注意，您开启这些权限即代表您授权我们可以收集和使用这些个人信息来实现上述的功能，您关闭权限即代表您取消了这些授权，则我们将不再继续收集和使用您的这些个人信息，也无法为您提供上述与这些授权所对应的功能。您关闭权限的决定不会影响此前基于您的授权所进行的个人信息的处理。除此以外，我们在相关业务功能中可能还需要您开启设备的其他访问权限，详细权限和使用目的如下：
                    </div>
                    <div>（1）android.permission.INTERNET（访问网络权限）：实现应用程序联网</div>
                    <div>（2）android.permission.CAMERA（允许程序访问摄像头进行拍照）：聊天时可发送现场拍摄的图片给客服</div>
                    <div>（3）android.permission.RECORD_AUDIO（允许程序录制声音通过手机或耳机的麦克）：聊天时可以客服发送语音消息</div>
                    <br/>
                    <h4 className='contentHeader'>
                        二、我们如何使用 Cookie 和同类技术
                    </h4>
                    <div>为使您获得更轻松的访问体验，您访问我们平台相关网站或使用我们平台提供的服务时，我们可能会通过小型数据文件识别您的身份，这么做是帮您省去重复输入注册信息的步骤，或者帮助判断您的账号安全。这些数据文件可能是Cookie，Flash Cookie，或您的浏览器提供的其他本地存储（统称“Cookie”）。</div>
                    <div>网页上常会包含一些电子图象（称为“单像素” GIF 文件或 “网络 beacon”），使用网络beacon可以帮助网站计算浏览网页的用户或访问某些cookie，我们会通过网络beacon收集您浏览网页活动的信息，例如您访问的页面地址、您先前访问的援引页面的位址、您停留在页面的时间、您的浏览环境以及显示设定等。</div>
                    <div>我们可能使用您在我们网站浏览的行为数据，根据您的兴趣喜好，在您浏览网站时有可能展现与您兴趣相关的信息或内容，这个过程包括以下几个方面：</div>
                    <div>（1）兴趣数据的收集：我们通过您在我们浏览过的内容，使用Cookie收集并保存您的行为数据。</div>
                    <div>（2）根据您的浏览行为数据，获取您的兴趣分类。例如您最近两天寻找上海家政公司信息，我们会了解您的兴趣是上海的家政公司。</div>
                    <div>我们不会将上述技术收集的信息用于本隐私保护声明所述目的之外的任何用途。请您理解，我们的某些服务只能通过使用“Cookie”才可得到实现。如果您的浏览器或浏览器附加服务允许，您可以在相关的页面修改对Cookie的接受程度，但这一举动在某些情况下可能会影响您安全访问我们相关网站和使用我们平台提供的服务。</div>
                    <br/>
                    <h4 className='contentHeader'>三、我们如何共享、转让、公开披露、合理使用您的个人信息</h4>
                    <div className='boldContent'>（一）共享</div>
                    <div>我们不会与我们以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</div>
                    <div>1、在获得明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</div>
                    <div>2、根根据法律法规的规定和行政、司法机构的要求：我们可能会根据法律法规规定，或按政府主管部门的强制性要求，向上述监管部门共享您的个人信息。</div>
                    <div>3、与我们的关联公司共享：您的个人信息可能会与我们的关联公司共享。我们只会共享必要的个人信息，且受本隐私保护声明中所声明目的的约束。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。关联公司指我们平台运营主体直接或间接控制的法人实体及其分支机构，与我们平台运营主体直接或间接共同受控于同一实际控制人的法人实体及其分支机构；控制、受控指：通过协议或股权控制或受控。</div>
                    <div>4、与授权合作伙伴共享：仅为实现本隐私保护声明中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的说明、本隐私保护声明以及其他任何相关的保密和安全措施来处理个人信息。</div>
                    <div>5、以学术研究或公共利益为目的，且无害于您的重大利益。</div>
                    <div>6、如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷。</div>
                    <div>7、只有共享您的信息，才能处理您与他人的纠纷或争议。例如您在温州莱泽气动科技有限公司上创建的某一交易信息中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，我们会视情况向该用户提供其交易对方的联络方式等必要信息，以促成纠纷的解决；</div>
                    <div>8、只有共享您的信息，才能提供您需要的服务或提供对应的帮助。例如在您要求我们的注册商户提供服务时，该商户在2小时内为您提供服务，如果未及时提供服务，为了更好的为您（包含注册和非注册客户）服务，我们可以寻找在本网站注册的其他相似注册商户为您提供该类服务。如您不同意我们推荐的商户提供服务可直接拒绝。</div>
                    <div className='boldContent'>（二）转让</div>
                    <div>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</div>
                    <div>1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</div>
                    <div>2、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私保护声明的约束，否则我们将要求该公司、组织重新向您征求授权同意。</div>
                    <div className='boldContent'>（三）公开披露</div>
                    <div>我们仅会在以下情况下，公开披露您的个人信息：</div>
                    <div>1、获得您明确同意后。</div>
                    <div>2、基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会对上述监管部门披露您的个人信息。</div>
                    <div>因此，请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。如要求从我们的服务中删除您的相关信息，请通过本隐私保护声明中提供的联系方式操作。</div>
                    <br/>
                    <h4 className='contentHeader'>四、我们如何保护和保存您的个人信息</h4>
                    <div className='boldContent'>（一）信息存储</div>
                    <div>我们收集的有关您的信息和资料将保存在我们及（或）其关联公司的服务器上，这些信息和资料全部储存在中国境内。目前，我们的产品和服务不会涉及到数据的跨境传输，如果我们的产品\服务发生变更，涉及数据的跨境传输，我们会单独向您以弹窗或邮件的方式告知您数据出境的目的、接收方等，并征得您的授权同意，我们会确保数据接收方有充足的数据保护能力来保护您的个人信息。</div>
                    <div className='boldContent'>（二）信息保护</div>
                    <div>为保障您的信息安全，我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。我们会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，我们将尽力做到使您的信息不被泄漏、毁损或丢失。</div>
                    <div className='boldContent'>1、数据加密：</div>
                    <div>我们对于用户的用户名、手机号、注册邮箱、qq号进行加密存储，保证用户基本信息不会被恶意获取。</div>
                    <div className='boldContent'>2、身份鉴别：</div>
                    <div>我们通过校验账号密码或者账号绑定手机验证码，进行用户身份合法性鉴别，防止非经授权的介入。</div>
                    <div className='boldContent'>3、访问控制：</div>
                    <div>我们对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施。我们用户在进行身份鉴别后，才能查询并管理用户信息和资源，未经过身份鉴别，不能管理用户资源。</div>
                    <div className='boldContent'>4、安全审计：</div>
                    <div>我们有时会接入风控平台或认证平台，对一些场景或行为进行监测。如通过流量分析，完成账号异常登陆、注册等异常行为的监控。</div>
                    <div className='boldContent'>5、账号保护：</div>
                    <div>您的账号均有安全保护功能，请妥善保管您的账号及密码信息。我们将通过向其它服务器备份、对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您理解，由于技术的限制以及可能存在的各种恶意手段，即便竭尽所能加强安全措施，在信息网络上也不存在“完善的安全措施”。如因您自己的原因导致账号及密码信息泄露而造成的任何法律后果需由您本人负责。在使用我们平台服务进行网上交易时，如您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息（例如联系人、联络方式等），请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息已经被泄露或者存在被泄露的可能，且有可能会危及您注册获得的温州莱泽气动科技有限公司账号安全，或者给您造成其他的损失的，请您务必在第一时间根据本隐私保护声明提到的联系方式与我们取得联系，以便我们采取相应措施维护您的温州莱泽气动科技有限公司账号安全，防止损失的发生或者进一步扩大。</div>
                    <div className='boldContent'>6、互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。</div>
                    <div>在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</div>
                    <br/>
                    <h4 className='contentHeader'>五、您如何管理个人信息</h4>
                    <div>我们非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：</div>
                    <div className='boldContent'>1、访问和更正您的个人信息</div>
                    <div>除法律法规规定外，您有权随时访问和更正您的个人信息。PC端，您可以通过进入“个人中心”查看您的个人信息，并可以通过 “我的资料”更正您的用户名、联系方式、邮箱、密码等个人信息。移动端，您可以进入“我的”- “账户管理”查询和更正您的联系方式、密码等个人信息。</div>
                    <div className='boldContent'>2、删除您的个人信息</div>
                    <div>您在温州莱泽气动科技有限公司的“已发布信息”或“全部信息”页面中可以直接隐藏或删除您发布的信息，在以下情形中，您可以向我们提出删除个人信息的请求：</div>
                    <div>（1）如果我们处理个人信息的行为违反法律法规；</div>
                    <div>（2）如果我们收集、使用您的个人信息，却未征得您的同意；</div>
                    <div>（3）如果我们处理个人信息的行为违反了与您的约定；</div>
                    <div>（4）如果我们终止服务及运营。</div>
                    <div>若我们决定响应您的删除请求，我们需确认您属于该信息的个人信息的实体或您已获得该信息实体的独立授权。当您从我们的服务中删除信息后，可能不会立即备份从系统中删除相应的信息，但会在系统备份更新时删除此信息。</div>
                    <div className='boldContent'>3、改变您授权同意的范围或撤回您的授权</div>
                    <div>您可以通过删除信息、关闭设备功能、在设备隐私设置等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。您也可以通过注销账号的方式，撤回我们继续收集您个人信息的全部授权。</div>
                    <div>请您理解，每个业务功能需要一些基本的个人信息才能得以完成，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。</div>
                    <div className='boldContent'>4、注销账号</div>
                    <div>您可以通过我们客服等官方渠道要求我们注销您的账号。您注销账号后，我们将停止为您提供服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息。</div>
                    <div className='boldContent'>5、约束信息系统自动决策</div>
                    <div>在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制作出决定。如果这些决定显著影响您的合法权益，您有权要求我们作出解释，我们也将提供适当的救济方式。</div>
                    <div className='boldContent'>6、响应您的请求</div>
                    <div>如果您无法通过上述方式访问、更正或删除您的个人信息，或您需要访问、更正或删除您在使用我们产品与/或服务时所产生的其他个人信息，或您认为我们存在任何违反法律法规或与您关于个人信息的收集或使用的约定，您均可以通过本隐私保护声明提供的方式与我们联系。为了保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份，我们将在收到您反馈并验证您的身份后的三个工作日内答复您的请求。如您不满意，还可以提起民事诉讼，也可以向中央网信办举报（举报中心网址为：http://www.12377.cn，举报电话为：12377）。对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</div>
                    <div>在以下情形中，按照法律法规要求，披露您的信息无需经过您的同意</div>
                    <div>（1）与个人信息控制者履行法律法规规定的义务相关的；</div>
                    <div>（2）与国家安全、国防安全有关的；</div>
                    <div>（3）与公共安全、公共卫生、重大公共利益有关的；</div>
                    <div>（4）与犯罪侦查、起诉和审判等有关的；</div>
                    <div>（5）个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；</div>
                    <div>（6）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</div>
                    <div>（7）响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；</div>
                    <div>（8）涉及商业秘密的。</div>
                    <br/>
                    <h4 className='contentHeader'>六、未成年人的个人信息保护</h4>
                    <div>我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，未成年人不应创建自己的用户账号。</div>
                    <div>对于经父母同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。</div>
                    <div>尽管当地法律和习俗对未成年人的定义不同，但我们将不满18周岁的任何人均视为未成年人。</div>
                    <div>如果我们发现在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</div>
                    <div>对于可能涉及的不满18周岁的未成年人个人信息，我们进一步采取以下措施予以保障：</div>
                    <div>1、对于收集到的未成年人的个人信息，我们除遵守本隐私保护声明关于用户个人信息保护的约定外，还会切实按照《未成年人个人信息网络保护规定》的要求，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则。</div>
                    <div>2、我们严格遵循《网络安全法》、《中华人民共和国未成年人保护法》、《儿童个人信息网络保护规定》等法律法规的要求进行存储、使用、披露收集到的未成年人个人信息，且不会超过实现收集、使用目的所必须的期限，到期后我们会对未成年人个人信息进行删除或匿名化处理。</div>
                    <div>3、我们设立的个人信息保护邮箱（laizekj@laizekj.com），凡涉及未成年人个人信息保护相关事宜我们将会有专人负责对接。我们还会制定未成年人个人信息保护的内部专门制度。</div>
                    <div>4、当您作为监护人为被监护的未成年人选择我们相关服务时，我们可能需要向您收集被监护未成年人的个人信息，用于向您履行相关服务之必要。在具体的服务中需要向您收集未成年人个人信息的，我们会事先取得您的授权同意，并告知您收集的目的和用途。如果您不提供前述信息，您将无法享受我们提供的相关服务。此外，您在使用晒单、评价等功能时，可能会主动向我们提供未成年人的个人信息，请您明确知悉并谨慎选择。您作为监护人应当正确履行监护职责，有义务保护未成年人个人信息安全。若未成年人本人需要注册或使用我们的产品或服务，您应当正确引导并予以监护。</div>
                    <div>5、未成年人或者监护人有权访问、更正、删除未成年人个人信息。如您对未成年人个人信息相关事宜有任何意见、建议和诉求，请联系我们。我们会随时为您提供服务。</div>
                    <br/>
                    <h4 className='contentHeader'>七、修订和更新</h4>
                    <div>1、为给您提供更好的服务以及随着我们业务的发展，本隐私保护声明也会随之更新。但未经您明确同意，我们不会削减您依据本隐私保护声明所应享有的权利。我们会通过在我们网站、移动端上发出更新版本并在生效前通过网站公告或以其他适当方式提醒您相关内容的更新，也请您访问莱泽之家以便及时了解最新的隐私保护声明。</div>
                    <div>2、对于重大变更，我们还会提供更为显著的通知（我们会通过包括邮件、短信或在浏览页面做特别提示等方式，说明隐私保护声明的具体变更内容）。本声明所指的重大变更包括：</div>
                    <div>（1）我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</div>
                    <div>（2）我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</div>
                    <div>（3）个人信息共享、转让或公开披露的主要对象发生变化；</div>
                    <div>（4）您参与个人信息处理方面的权利及其行使方式发生重大变化；</div>
                    <div>（5）我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</div>
                    <div>（6）个人信息安全影响评估报告表明存在高风险时。</div>
                    <div>您除了在莱泽之家进行注册时，可以查看到最新版本的隐私保护声明外；您可以在莱泽之家首页下方查看到我们最新版本的《莱泽隐私政策》。</div>
                    <br/>
                    <h4 className='contentHeader'>八、如何联系我们</h4>
                    <div>如您对本隐私政策有任何疑问或您在使用我们提供的服务时个人信息受到了侵扰，您可以通过以下方式联系我们</div>
                    <div>1.拨打电话：400-686-0606 </div>
                    <div>2.发送邮件至laizekj@laizekj.com</div>
                </body>
            </div>
        );
    }
}

export default LZPrivacyDetailPage;